'use client';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from '../utils/translations';

export default function JulyPredictionSection() {
  const { t } = useTranslations();
  
  return (
    <section className="w-full bg-[var(--bg-main)] py-4 sm:py-6 md:py-8 lg:py-[28px] pb-[45px]">
      <div className="w-full max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Column */}
        <div className="flex flex-col justify-start items-center w-full gap-20">
          
          {/* Tarot Cards Image */}
          <Image
            src="/images/img_karty_vejir_1.png"
            alt={t('home.july_prediction.accessibility.cards_alt')}
            width={284}
            height={272}
            className="w-[210px] h-[201px] sm:w-[220px] sm:h-[210px] md:w-[220px] md:h-[210px] lg:w-[284px] lg:h-[272px] object-contain" />

          
          {/* Zobrazit karty Button */}
          <Link href="/cards-gallery">
            <button className="bg-[#77C0BB] text-black font-bold rounded-full shadow-lg py-3 px-6 flex items-center justify-center gap-3 transition-all duration-300 ease-in-out border-2 border-[#77C0BB] hover:scale-105 hover:shadow-xl active:scale-95 active:opacity-90">

                  <div className="flex items-center gap-3 flex-wrap justify-center">
                  <span className="break-words">{t('home.july_prediction.show_cards_button')}</span>
                  <Image
                  src="/images/img_vector_black_900.svg"
                  alt={t('home.july_prediction.accessibility.arrow_alt')}
                  width={22}
                  height={14}
                  className="w-[18px] h-[12px] sm:w-[20px] sm:h-[13px] md:w-[22px] md:h-[14px] flex-shrink-0" />
                  </div>
            </button>
          </Link>
          
          {/* Transparent Frame with Border and Corner Loops */}
          <div className="relative w-full max-w-[850px] mx-auto">
            {/* --- ROHY --- */}

              {/* Horní levé: Plné (to čáry zakryje samo o sobě) */}
              <div className="absolute -top-2 -left-2 w-4 h-4 sm:w-5 sm:h-5 bg-[#cfb284] rounded-full z-30" />
    
              {/* Horní pravé: Prázdné se "záplatou" */}
              <div className="absolute -top-2 -right-2 z-20 flex items-center justify-center">
                {/* Záplata v barvě pozadí, která schová čáry */}
                <div className="absolute w-5 h-5 bg-main" /> 
                {/* Prázdné kolečko */}
                <div className="relative w-4 h-4 sm:w-5 sm:h-5 border-2 border-[#cfb284] bg-main rounded-full z-30" />
              </div>
              
              {/* Dolní levé: Prázdné se "záplatou" */}
              <div className="absolute -bottom-2 -left-2 z-20 flex items-center justify-center">
                <div className="absolute w-5 h-5 bg-main" />
                <div className="relative w-4 h-4 sm:w-5 sm:h-5 border-2 border-[#cfb284] rounded-full z-30" />
              </div>
              
              {/* Dolní pravé: Plné */}
              <div className="absolute -bottom-2 -right-2 w-4 h-4 sm:w-5 sm:h-5 bg-[#cfb284] rounded-full z-30" />

              {/* --- HLAVNÍ BOX --- */}
              <div className="relative border-[3px] border-double border-[#cfb284]/60 p-4 bg-transparent z-10">
                <h2 className="text-center text-[var(--text-primary)] font-medieval text-[24px] sm:text-[32px] mb-6 underline decoration-[#cfb284]/40 underline-offset-8" style={{ fontFamily: 'MedievalSharp' }}>
                  {t('home.july_prediction.heading')}
                </h2>
                <p className="text-center text-[var(--text-primary)] font-inter font-medium text-[14px] sm:text-[16px] leading-relaxed max-w-2xl mx-auto">
                  {t('home.july_prediction.text')}
                </p>
              </div>
              
            </div>

                  </div>
                </div>
              </section>);

}